export default __webpack_public_path__ + "img/ng100.b70352f3.jpg";